<div class="rounded-xl shadow-md p-8 max-w-7xl mx-auto">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-6">
    <div class="flex flex-col md:flex-row md:items-end gap-6 w-full">
      <div class="flex-1 min-w-0">
        <label class="block mb-1 font-medium">Descrição <span class="text-red-500">*</span></label>
        <input
          pInputText
          formControlName="description"
          placeholder="Digite a descrição"
          class="w-full"
          [ngClass]="{ 'ng-invalid ng-dirty': isFieldInvalid('description') }"
        />
        <small class="text-red-500" *ngIf="isFieldInvalid('description')">Descrição é obrigatória</small>
      </div>
      <div class="flex items-center gap-2 shrink-0 md:pb-0.5">
        <p-checkbox formControlName="active" inputId="famActive" [binary]="true" />
        <label for="famActive" class="font-medium cursor-pointer">Ativo</label>
      </div>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6 items-end">
      <div>
        <label class="block mb-1 font-medium">Preço Venda <span class="text-red-500">*</span></label>
        <p-inputNumber
          formControlName="priceSelling"
          mode="currency"
          currency="BRL"
          locale="pt-BR"
          [minFractionDigits]="2"
          [maxFractionDigits]="2"
          [inputStyle]="{ width: '100%' }"
          class="w-full"
        />
        <small class="text-red-500" *ngIf="isFieldInvalid('priceSelling')">Obrigatório</small>
      </div>
      <div>
        <label class="block mb-1 font-medium">Preço Prazo</label>
        <p-inputNumber
          formControlName="priceTerm"
          mode="currency"
          currency="BRL"
          locale="pt-BR"
          [minFractionDigits]="2"
          [maxFractionDigits]="2"
          [inputStyle]="{ width: '100%' }"
          class="w-full"
        />
        <small class="text-red-500" *ngIf="isFieldInvalid('priceTerm')">Não pode ser negativo</small>
      </div>
      <div>
        <label class="block mb-1 font-medium">Preço Atacado</label>
        <p-inputNumber
          formControlName="priceWholeSale"
          mode="currency"
          currency="BRL"
          locale="pt-BR"
          [minFractionDigits]="2"
          [maxFractionDigits]="2"
          [inputStyle]="{ width: '100%' }"
          class="w-full"
        />
        <small class="text-red-500" *ngIf="isFieldInvalid('priceWholeSale')">Não pode ser negativo</small>
      </div>
    </div>
    <div>
      <button class="bg-orange-500 p-2 rounded-md text-white cursor-pointer" type="submit">Salvar</button>
    </div>
  </form>
</div>
